import React, { useEffect, useState } from 'react';
import { Box, Card, CardActionArea, CardContent, CardMedia, Container, Grid, Link, Paper, Stack, Typography, styled } from '@mui/material';

type Props = {
  label: string;
  description: string;
  link: string;
  image: string;
};
const Item = (props: Props) => {
  const { label, description, link, image } = props;

  return (
    <Card>
      <CardActionArea href={link} target='_blank' rel='noreferrer' LinkComponent='a'>
        <CardMedia
          component='img'
          height="256"
          width="256"
          image={image}
        />
        <CardContent>
          <Typography gutterBottom variant='body1' component="div" textAlign='center'>
            {label}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export const Index = () => {
  return (
    <Container disableGutters>
      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid item xs={3}>
          <Item 
            label='MUNICIPAL HOUSING' 
            description='' 
            link='https://www.google.com/maps/d/u/0/edit?mid=1CIKpb-v_m7uLrHPpN__eveORxLZlFuJE' 
            image='/icons/MUNICIPAL HOUSING.png' />
        </Grid>
        <Grid item xs={3}>
          <Item 
            label='CLEANERS AREA' 
            description='' 
            link='https://www.google.com/maps/d/u/0/viewer?mid=1m68v21-xr7-ZFEOT-T0M_ulIFbghHKVX&ll=26.05880911389814%2C43.997609172588874&z=13' 
            image='/icons/CLEANERS AREA.png' />
        </Grid>
        <Grid item xs={3}>
          <Item 
            label='GARBAGE CAR AREA' 
            description='' 
            link='https://www.google.com/maps/d/u/0/viewer?mid=1-svM8t21oKyrhfro-tPUOgNH2XCkod9u&ll=26.092149392059014%2C43.97127363987085&z=15' 
            image='/icons/GARBAGE CAR AREA.png' />
        </Grid>
        <Grid item xs={3}>
          <Item 
            label='DANA AREA' 
            description='' 
            link='https://www.google.com/maps/d/u/0/viewer?mid=1yXQgZ9kB1OBeVw1jRVp5QXg3aRoEjPq2&ll=26.08039511976627%2C44.00225369999998&z=12' 
            image='/icons/DANA AREA.png' />
        </Grid>
      </Grid>
    </Container>
  );
};